/** 当前哈臻快新项目路由 */
export enum RechargeH5RouteEnum {
  /** 协议列表页 */
  LEGAL_CONTRACT = 'legal-contract',
}

/** 协议场景枚举 */
export enum ContractSceneEnum {
  /** 登录模块-跳转承接协议列表 */
  LOGIN_PAGE = '1',
  /** a面落地页-跳转承接协议列表 */
  A_MARKET = '2',
  /** b面金融协议授权弹窗-跳转承接协议列表 */
  B_DIALOG = '3',
}
